/* eslint-disable @typescript-eslint/explicit-function-return-type */

import { globals } from "@/globals";

export function importMathJs() {
	return import("mathjs");
}

export function loadDependencies() {
	window.setTimeout(() => {
		importMathJs()
			.then((math) => {
				globals.mathJs = math;
			})
			.catch(console.error);
	}, 1000);
}
